import { Link, useNavigate } from 'react-router-dom';
import { FINALE_LOCATION } from '../data/enigmas';
import { useProgress } from '../hooks/useProgress';
import voucherImage from '../../Images/GiftVoucher500500.png';

export default function CompletePage() {
  const navigate = useNavigate();
  const { allDone, solvedCount, total, reset } = useProgress();

  if (!allDone) {
    return (
      <main className="fh-page fh-page--complete">
        <div className="fh-atmosphere" aria-hidden="true" />
        <div className="fh-vignette" aria-hidden="true" />
        <div className="fh-panel fh-panel--intro">
          <p className="fh-eyebrow">Festa da História</p>
          <h1 className="fh-brand fh-brand--small">Ainda faltam enigmas</h1>
          <p className="fh-lede">
            Progresso: {solvedCount}/{total}. Continua no mapa.
          </p>
          <Link className="fh-btn fh-btn--primary" to="/festa-historia/mapa">
            Voltar ao mapa
          </Link>
        </div>
      </main>
    );
  }

  return (
    <main className="fh-page fh-page--finale">
      <div className="fh-atmosphere" aria-hidden="true" />
      <div className="fh-vignette" aria-hidden="true" />

      <div className="fh-finale">
        <h1 className="fh-finale__title">{FINALE_LOCATION.message}</h1>
        <p className="fh-finale__urgency">{FINALE_LOCATION.urgency}</p>

        <section className="fh-finale-block fh-finale-block--photo" aria-label="Foto de conclusão">
          <p className="fh-finale-block__kicker">Próximo passo</p>
          <h2 className="fh-finale-block__title">{FINALE_LOCATION.photoTitle}</h2>
          <p className="fh-finale-block__text">{FINALE_LOCATION.photoLead}</p>
        </section>

        <section
          className="fh-finale-voucher fh-finale-voucher--enter"
          aria-label="Oferta de voucher"
        >
          <p className="fh-finale-block__kicker">Recompensa</p>
          <img
            src={voucherImage}
            alt="Voucher Escape Room Bragança"
            className="fh-finale-voucher__image"
          />

          <div className="fh-finale-voucher__card">
            <p className="fh-finale-voucher__badge">
              {FINALE_LOCATION.discountPercent}% de desconto
            </p>
            <p className="fh-finale-voucher__text">
              Compra um voucher com o código{' '}
              <span className="fh-finale-voucher__code">
                {FINALE_LOCATION.discountCode}
              </span>{' '}
              até ao {FINALE_LOCATION.discountUntilLabel}, beneficia de{' '}
              {FINALE_LOCATION.discountPercent}% de desconto e destrói o próximo
              plano dele.
            </p>
            <Link className="fh-btn fh-btn--primary" to="/vouchers/?code=FestaHistoria">
              Comprar voucher
            </Link>
          </div>
        </section>

        <button
          type="button"
          className="fh-btn fh-btn--ghost fh-finale__reset"
          onClick={() => {
            reset();
            navigate('/festa-historia');
          }}
        >
          Reiniciar neste aparelho
        </button>

        <Link className="fh-text-link" to="/festa-historia">
          Voltar ao início
        </Link>
      </div>
    </main>
  );
}
